module.exports = __webpack_public_path__ + "media/images/add-driver-70c1da63f52d06c574d6d42e49184273.svg";